export const IGNORED_ERRORS = new WeakSet<Error>();
